import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dericcain/Code/react-tiny-fab/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`<img alt="React Tiny FAB" src="https://raw.githubusercontent.com/dericgw/react-tiny-fab/master/logo.png" />`}</p>
    <blockquote>

      <p {...{
        "parentName": "blockquote"
      }}>{`A tiny (~700 byte gzip) WAI-ARIA compliant Floating Action Button for React`}</p>

    </blockquote>
    <blockquote>

      <p {...{
        "parentName": "blockquote"
      }}><inlineCode {...{
          "parentName": "p"
        }}>{`react-tiny-fab`}</inlineCode>
        {` v3 now relies on React version 16.8 and up because it is implemented using `}
        <a {...{
          "href": "https://reactjs.org/docs/hooks-intro.html",
          "parentName": "p"
        }}>{`React Hooks`}</a></p>

    </blockquote>
    <p>{`Want to use a Floating Action Button without having to import the whole Material Design Components library? Weighing in
at only around 671 bytes gzipped, React Tiny FAB is a great solution. It is a lightweight, fast, and flexible component.`}</p>
    <p>{`<img alt="React Tiny FAB" src="https://raw.githubusercontent.com/dericgw/react-tiny-fab/master/fab.gif" />`}</p>
    <h2 {...{
      "id": "docs"
    }}>{`Docs`}</h2>
    <p>{`Please visit here for docs: `}
      <a {...{
        "href": "https://dericgw.github.io/react-tiny-fab",
        "parentName": "p"
      }}>{`https://dericgw.github.io/react-tiny-fab`}</a></p>
    <h2 {...{
      "id": "issues"
    }}>{`Issues`}</h2>
    <p>{`If you find an issue, head over to the `}
      <a {...{
        "href": "https://github.com/dericgw/react-tiny-fab/issues",
        "parentName": "p"
      }}>{`Issues`}</a>
      {` section and let me
know about it. If you want to be super cool, you can submit a PR that fixes the issue.`}</p>
    <h2 {...{
      "id": "license-mit"
    }}>{`License (MIT)`}</h2>
    <p><a {...{
        "href": "https://github.com/dericgw/react-tiny-fab/blob/master/LICENSE",
        "parentName": "p"
      }}>{`Check it out here.`}</a></p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      